package org.hs_soft.runmynesto.domain.model.home.customer_card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager.getCurrentStrings
import org.hs_soft.runmynesto.domain.util.helper.Strings


// 1. First, modify the enum class to accept a function that provides the string
enum class CustomerCardHeaderEnum(
    private val titleProvider: () -> String
) {
    CUSTOMER_CARD(
        titleProvider = { getCurrentStrings().customerCard }
    ),
    SERIES(
        titleProvider = {  getCurrentStrings().series }
    );

    // Add a composable getter for the title
    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            CUSTOMER_CARD -> strings.customerCard
            SERIES -> strings.series
        }
    }

    val title: String
        get() = titleProvider()
}